import { Button, Dialog } from '@material-ui/core'
import CrossIcon from 'assets/img/cross.svg'
import { PopupLoader } from 'components'
import * as React from 'react'
import ReactSVG from 'react-svg'
import { AddChildForm as Form } from './form'
import './style.scss'

interface IState {}

interface IProps {
  open: boolean
  onSubmit: () => void
  onClose: () => void
  onChangeGender: () => void
  isValidForm: boolean
  loading: boolean
}

export class CreateChildModal extends React.Component<IProps, IState> {
  isBackButtonClicked: boolean

  fullScreen = () => true

  render() {
    const { onSubmit, open, onClose, onChangeGender, loading } = this.props

    return (
      <Dialog
        fullScreen={this.fullScreen()}
        open={open}
        onClose={onClose}
        PaperProps={{
          className: 'dialog-modal-paper dialog-modal-paper--create-child'
        }}
      >
        <PopupLoader active={loading} />

        <div className="create-child-container">
          <div className="create-child-content design-fixes">
            <div className="title">Create child profile</div>
            <div className="form-container">
              <Form onChangeRadio={onChangeGender} />
            </div>
            <div className="btn-wrapper">
              <Button
                className="create-child-button"
                onClick={() => {
                  onSubmit()
                }}
              >
                Add child
              </Button>
            </div>
            <div
              className="cross-icon"
              onClick={() => {
                onClose()
              }}
            >
              <ReactSVG src={CrossIcon} />
            </div>
          </div>
        </div>
      </Dialog>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/CreateChildModal/index.tsx